import account from "./account"
import approval from "./approval"
import articles from "./articles"
import avab_item from "./avab_item"
import content from "./content"
import demo from "./demo"
import erp_account from "./erp/account"
import erp_business from "./erp/business"
import erp_contact_legalperson from "./erp/contact/legalperson"
import erp_contact_member from "./erp/contact/member"
import erp_contact_naturalperson from "./erp/contact/naturalperson"
import erp_contact_shop from "./erp/contact/shop"
import erp_contact_user from "./erp/contact/user"
import erp_product from "./erp/product"
import erp_shop from "./erp/shop"
import erp_logistics from "./erp/logistics"
import erp from "./erp"
import hub123 from "./hub123"
import inquire_item from "./inquire_item"
import login from "./login"
import products from "./products"
import rfq_item from "./rfq_item"
import search from "./search"
import supply_item from "./supply_item"
import upload from "./upload"
import routerDeal from "./routerDeal"
import pay from "./pay"
import chat from "./chat"
import api from "./api"
import publish from "./publish"
import workBoard from "./work-board"
import { storage } from '~/common/utils/storage';
import axios from '~/common/plugins/axios.js'
import { getSessionToken, getColumnDetail } from '~/common/utils/index';

Vue.use(Vuex)
export const state = () => ({
  sessionToken: '', // 服务端请求时需要的token
  auth: '', // 客户端请求时需要的token
  ssrTokenStatus: 'initial', // 服务端感知的token状态，initial=初始，valid=有效，empty=为空，invalid=失效
  isSpread: true,
  isSubSpread: true,
  isFullScreen: false,
  isSubFullScreen: false,
  // 国家区号数据列表
  countryList: [],
  // 币种列表
  currencyList: [],
  // 芯联行代表列表
  shop_member: [],
  // 税率列表
  taxesList: [],
  // 地址地区列表
  regionList: [],
  // 文件夹列表
  foldersList: [],
  // 终端类型：''和pc-电脑端，mob-移动端
  // 默认为''，问卷和邀请页需要监听从''到pc或mob的过程，从而做loading状态
  platformType: '',
  socketMsg: {},
  detail_top: false, //隐藏操作后，调整侧拉高度
  moreSearchFilter: false, //监听tableFilter,做页面布局优化
  moreSearch: false, //监听tableFilter,做页面布局优化
  expandState: false, //是否打开扩展按钮
  addingState: false, //是否处于新增状态
  detailData: {}, //详情
  expandNone: false,
  triggerTurnSellOrPurchase: 1, //转采购，转销售。需要刷新
  shippingsData: {}, //货运方式
  shopPlaneMs:{}, //成员显示
});

// 是否正在请求税率代码接口
let isFetchingTaxes = false;
// 是否正在请求国家代码接口
let isFetchingCountryCode = false;
// 是否正在请求币种接口
let isFetchingCurrency = false;
// 是否正在请求区域接口
let isFetchingRegion = false;
// 是否正在请求文件夹接口
let isFetchingFolders = false;

export const mutations = {
  set_shopPlaneMs(state, v) {
    //shop——member详情
    state.shopPlaneMs = v
  },
  set_ssrTokenStatus(state, v) {
    state.ssrTokenStatus = v;
  },
  set_auth(state, v) {
    state.auth = v;
    state.sessionToken = v;
  },
  set_spread(state, v) {
    state.isSpread = v;
  },
  set_sub_spread(state, v) {
    state.isSubSpread = v;
  },
  set_screen(state, v) {
    state.isFullScreen = v;
  },
  set_sub_screen(state, v) {
    state.isSubFullScreen = v;
  },
  set_countryList(state, v) {
    state.countryList = v;
  },
  set_currencyList(state, v) {
    state.currencyList = v;
  },
  set_taxesList(state, v) {
    state.taxesList = v;
  },
  set_foldersList(state, v) {
    state.foldersList = v;
  },
  set_regionList(state, v) {
    const regionList = v.map(({ id, nation_name, child }) => {
      return {
        value: id,
        label: nation_name,
        children:
          child &&
          child.map(({ id, province_name, child }) => {
            return {
              value: id,
              label: province_name,
              children:
                child &&
                child.map(({ id, city_district_name }) => ({
                  value: id,
                  label: city_district_name
                }))
            };
          })
      };
    });
    state.regionList = regionList;
  },
  set_platform_type(state, v) {
    state.platformType = v;
  },
  set_socketMsg(state, v) {
    state.socketMsg = v;
  },
  set_detail_top(state, v) {
    state.detail_top = v;
  },
  set_moreSearchFilter(state, v) {
    state.moreSearchFilter = v;
  },
  set_moreSearch(state, v) {
    state.moreSearch = v;
  },
  set_expandState(state, v) {
    state.expandState = v;
  },
  set_expandNone(state, v) {
    state.expandNone = v;
  },
  set_addingState(state, v) {
    state.addingState = v;
  },
  set_detail_data(state, v) {
    state.detailData = v;
  },
  set_triggerTurnSellOrPurchase(state,v) {
    state.triggerTurnSellOrPurchase = v;
  },
  set_shop_member(state, v) {
    state.shop_member = v;
  },
};

export const actions = {
  async getCaptchaID({ commit }) {
    const captchaID = await axios.$get('back/v1/login/captchaid');
  },
  // 1.等待国家区号接口响应
  countryListWaiter({ state }) {
    if (this.countryCodeTimer && process.client) window.clearInterval(this.countryCodeTimer);

    return new Promise((resolve) => {
      if (!process.client) return resolve([]);

      this.countryCodeTimer = window.setInterval(() => {
        if (isFetchingCountryCode === false) {
          window.clearInterval(this.countryCodeTimer);
          resolve(state.countryList);
        }
      }, 200);
    });
  },
  setMoreSearchFilter({commit},payload){
    setTimeout(() => {
      commit('set_moreSearchFilter',payload)
    })
  },
  setMoreSearch({commit},payload){
    setTimeout(() => {
      commit('set_moreSearch',payload)
    })
  },
  // 1.获取国家区号
  async getCountryList({ state, commit, dispatch }) {
    if (state.countryList.length > 0) {
      return state.countryList;
    } else {
      if (isFetchingCountryCode) {
        const data = await dispatch('countryListWaiter');
        return data;
      } else {
        isFetchingCountryCode = true;
        const { code, data } = await axios.$post('/rest/store/contact/v3/nation/query', {page_size: 1000});

        if (code !== 200) {
          isFetchingCountryCode = false;
          return [];
        }

        commit('set_countryList', data);
        isFetchingCountryCode = false;
        return data;
      }
    }
  },
  // 2.等待币种接口响应
  currencyWaiter({ state }) {
    if (this.currencyTimer && process.client) window.clearInterval(this.currencyTimer);

    return new Promise((resolve) => {
      if (!process.client) return resolve([]);

      this.currencyTimer = window.setInterval(() => {
        if (isFetchingCurrency === false) {
          window.clearInterval(this.currencyTimer);
          resolve(state.currencyList);
        }
      }, 200);
    });
  },
  // 2.获取币种列表
  async getCurrencyList({ state, commit, dispatch }) {
    if (state.currencyList.length > 0) {
      return state.currencyList;
    } else {
      if (isFetchingCurrency) {
        const data = await dispatch('currencyWaiter');
        return data;
      } else {
        isFetchingCurrency = true;
        // 此接口偶尔500错误
        // const res = await axios.$get('/rest/store/general/v3/currencies/GetCurrencyInfoListByType');
        const res = await axios.$get('api/general/v1/currencies/GetCurrencyInfoListByType');
        if (!res || (res && res.code !== 200)) {
          isFetchingCurrency = false;
          return [];
        }

        commit('set_currencyList', res.data.list);
        if (process.client) {
          storage.set('currency', res.data.list);
        }
        isFetchingCurrency = false;
        return res.data.list;
      }
    }
  },
  // 3.等待地区列表接口响应
  regionListWaiter({ state }) {
    if (this.regionTimer && process.client) window.clearInterval(this.regionTimer);

    return new Promise((resolve) => {
      if (!process.client) return resolve([]);

      this.regionTimer = window.setInterval(() => {
        if (isFetchingRegion === false) {
          window.clearInterval(this.regionTimer);
          resolve(state.regionList);
        }
      }, 200);
    });
  },
  // 3.获取地区列表
  async getRegionList({ state, commit, dispatch }) {
    if (state.regionList.length > 0) {
      return state.regionList;
    } else {
      if (isFetchingRegion) {
        const data = await dispatch('regionListWaiter');
        return data;
      } else {
        isFetchingRegion = true;
        const res = await axios.$post('/rest/store/contact/v3/address/list',{});
        if (!res || (res && res.code !== 200)) {
          isFetchingRegion = false;
          return [];
        }

        commit('set_regionList', res.data.list);
        isFetchingRegion = false;
        return res.data.list;
      }
    }
  },
  // 4.等待税率列表接口响应
  taxesListWaiter({ state }) {
    if (this.taxesTimer && process.client) window.clearInterval(this.taxesTimer);

    return new Promise((resolve) => {
      if (!process.client) return resolve([]);

      this.taxesTimer = window.setInterval(() => {
        if (isFetchingRegion === false) {
          window.clearInterval(this.taxesTimer);
          resolve(state.taxesList);
        }
      }, 200);
    });
  },
  // 4.获取税率列表
  async getTaxesList({ state, commit, dispatch }, params = {}) {
    if (state.taxesList.length > 0) {
      return state.taxesList;
    } else {
      if (isFetchingTaxes) {
        const data = await dispatch('taxesListWaiter');
        return data;
      } else {
        isFetchingTaxes = true;
        const res = await axios.$post('/rest/erp/general/v3/taxes/lookup', {
          current: 1,
          page_size: 10000,
          active: true,
          ...params
        });

        if (!res || (res && res.code !== 200)) {
          isFetchingTaxes = false;
          return [];
        }

        commit('set_taxesList', res.data.list);
        isFetchingTaxes = false;
        return res.data.list;
      }
    }
  },
  // 5.等待文件夹列表接口响应
  foldersListWaiter({ state }) {
    if (this.folderTimer && process.client) window.clearInterval(this.folderTimer);

    return new Promise((resolve) => {
      if (!process.client) return resolve([]);

      this.folderTimer = window.setInterval(() => {
        if (isFetchingRegion === false) {
          window.clearInterval(this.folderTimer);
          resolve(state.foldersList);
        }
      }, 200);
    });
  },
  // 5.获取文件夹列表
  async getFoldersList({ state, commit, dispatch }, params = {}) {
    if (state.foldersList.length > 0) {
      return state.foldersList;
    } else {
      if (isFetchingFolders) {
        const data = await dispatch('foldersListWaiter');
        return data;
      } else {
        isFetchingFolders = true;
        const res = await axios.$post('/rest/store/general/v3/service_folder/search', {
          current: 1,
          is_enable: true,
          ...params
        });

        if (!res || (res && res.code !== 200)) {
          isFetchingFolders = false;
          return [];
        }

        commit('set_foldersList', res.data.list);
        isFetchingFolders = false;
        return res.data.list;
      }
    }
  },
  // 法本 服务端处理登录状态，通过store传递给客户端页面。并且如果已登录，就在这里获取用户信息
  async nuxtServerInit({ commit }, { req }) {
    // 抽出公共函数复用
    const setLoginStatus = async (auth, ssrTokenStatus, loginFlag, isLogin) => {
      await commit('set_auth', auth);
      await commit('set_ssrTokenStatus', ssrTokenStatus);
      await commit('login/set_loginFlag', loginFlag);
      await commit('content/setIsLogin', isLogin);
    };
    // 服务端没有cookie，证明没有登录信息，则全部清空登录状态和当前栏目信息
    if (!req?.headers?.cookie) {
      setLoginStatus('', 'empty', false, false);
      commit('content/set_column_detail', { column_id: '', shop_id: '', name: '' });
      return;
    }
    // 有cookie时，通过cookie尝试拿当前栏目信息
    await commit('content/set_column_detail', getColumnDetail(req.headers.cookie));
    // 有cookie时，通过cookie尝试拿token
    const sessionToken = getSessionToken(req.headers.cookie);
    // 如果没拿到token，证明没登陆或者登录过期，则也全部清空登录状态
    if (!sessionToken) {
      setLoginStatus('', 'empty', false, false);
      return;
    }
    // 如果拿到了token，并不一定是有效的，需要去拿用户信息以验证是否有效
    await commit('set_auth', sessionToken); // 这一步是为了下面的axios的header里带上token
    try {
      const axiosPromise = await axios.$get('/rest/store/contact/v3/users/traits');
      switch (axiosPromise.code) {
        case 200:
          await setLoginStatus(sessionToken, 'valid', true, true);
          await commit('login/set_userProfile', axiosPromise.data || {});
          break;
        case 401:
          await setLoginStatus('', 'invalid', false, false);
          break;
        default:
          await setLoginStatus(sessionToken, 'error', false, false);
          break;
      }
    } catch {
      await setLoginStatus(sessionToken, 'error', false, false);
    }
  },
  //
  async getShopMemberList({ state, commit }, params) {
    if (state.shop_member.length > 0) {
      return state.shop_member;
    } else {
      params = {
        current: 1,
        page_size: 1000,
      }
      const {code, data} = await axios.$post(`/rest/erp/contact/v3/contactshopmembersidnamelist/shop`,params)
      if(code!==200) return;
      commit('set_shop_member', data.list);
      return data.list;
    }
  },
  //获取前台货运方式 没有权限
  async getShippingFront({ state, commit, dispatch }) {
    const {code, data: { list }} = await axios.$post(`rest/portal/logistics/v3/shipping/method/list`,{})
    if(code !== 200) {
      return
    }
    const json = {}
    const cnJson = {}
    list.map(v => {
      json[v.id] = v
      cnJson[v.name] = v
    })
    const data = {
      json,
      list,
      cnJson
    }
    storage.set('shippingsData', data, true)
    Vue.prototype.shippingsData = data
    return Promise.resolve(data)
  },
};
export default new Vuex.Store({
  modules: {
    "account": account,
    "approval": approval,
    "articles": articles,
    "avab_item": avab_item,
    "content": content,
    "demo": demo,
    "erp": {
      ...erp,
      modules: {
        "product": erp_product,
        "account": erp_account,
        "business": erp_business,
        "shop": erp_shop,
        "logistics": erp_logistics,
        "contact": {
          namespaced: true,
          modules: {
            "user": erp_contact_user,
            "legalperson": erp_contact_legalperson,
            "member": erp_contact_member,
            "naturalperson": erp_contact_naturalperson,
            "shop": erp_contact_shop,
          }
        }
      }
    },
    "hub123": hub123,
    "inquire_item": inquire_item,
    "login": login,
    "products": products,
    "rfq_item": rfq_item,
    "search": search,
    "supply_item": supply_item,
    "upload": upload,
    "routerDeal":routerDeal,
    "pay" : pay,
    "api":api,
    "chat":chat,
    "workBoard": workBoard,
    "publish":publish
  },
  state,
  actions,
  mutations
})
